// globals: jQuery
import {TerminalTransactionWebSocket} from "@cashflow/cashflow-websockets";
/**
 * CashFlowEMVTerminal
 *
 * @author Himanshu Rajput
 *
 * @param params
 * @constructor
 * @returns {CashFlowEMVTerminal}
 */
function CashFlowEMVTerminal(params) {
    this.params = params ? params : {};
}

const cancelTransaction = 'Cancel';
const cancelTransactionStatus = 6;
let cancelStatusCheck = 0;
let $dialogContent = jQuery('<div>'
    + '<p class="pos-terminal-text">Please process payment through the EMV terminal.</p>'
    + '</div>');
let conn = null;
/**
 * @description Connect EMV Terminal Request for CashFLow
 * @param params
 * @param callback
 */
CashFlowEMVTerminal.prototype.callTerminal = function (params, callback) {
    var self = this;
    window.TerminalTransactionWebSocket = TerminalTransactionWebSocket;
    var platformTransactionId;

    const handleOnError = function (error) {
        cancelEmvTerminalTransaction();
        jQuery.caAlert('Error on Processing Terminal Transaction.');
        console.error(error);
        $dialogContent.caDialog('close');
        $dialogContent.caDialog('destroy');
        self.callTerminalInProgress = false;
        if (conn !== null) {
            conn.closeConnection().then(r => {
                console.log('Terminal Connection Closed.');
            });
        }
        enablePayButton();
    };
    const handleOnTransactionEvent = function (data) {
        if (data.message === cancelTransaction && data.status === cancelTransactionStatus) {
            cancelEmvTerminalTransaction();
            jQuery.caAlert(
                'Transaction has been cancelled.',
                '' +
                '',
                {className: 'cf-close-alertbox'}
            );
            $dialogContent.caDialog('close');
            $dialogContent.caDialog('destroy');
            self.callTerminalInProgress = false;
            if (conn !== null) {
                conn.closeConnection().then(r => {
                    console.log('Terminal Connection Closed.');
                });
            }
            enablePayButton();
        }
        // callback(data);
    };

    const handleOnTransactionInitiated = function (data) {
        callback(data);
    };

    const handleOnTransactionSuccess = function (data) {
        console.log('onHandleOnTransactionSuccess');
        $dialogContent.caDialog('close');
        $dialogContent.caDialog('destroy');
        self.callTerminalInProgress = false;
        if (conn !== null) {
            conn.closeConnection().then(r => {
                console.log('Terminal Connection Closed.');
            });
        }

        data.platformTransactionId = platformTransactionId;
        callback(data);
    };

    const enablePayButton = function () {
        document.querySelector('#terminal').disabled = false;
        document.querySelector('#terminal').innerHTML = 'Pay';
    };

    const disablePayButton = function () {
        document.querySelector('#terminal').disabled = true;
        document.querySelector('#terminal').innerHTML = 'Processing...';
    };

    const handleOnTransactionError = function (data) {
        cancelEmvTerminalTransaction();
        $dialogContent.caDialog('close');
        if (data.hasOwnProperty('errorMessage')) {
            jQuery.caAlert('Terminal Error Occurred: ' + data.errorMessage);
        }
        $dialogContent.caDialog('destroy');
        self.callTerminalInProgress = false;
        if (conn !== null) {
            conn.closeConnection().then(r => {
                console.log('Terminal Connection Closed.');
            });
        }
        // callback(data);
        enablePayButton();
    };

    const closeDialogBox = (message) => {
        $dialogContent.caDialog('close');
        $dialogContent.caDialog('destroy');

        jQuery.caAlert(message);
        jQuery('body').caLoadingSplash('hide');
    }

    const cancelEmvTerminalTransaction = () => {
        const url = '/payment/clear-terminal-request';
        const parameters = {
            'user_id': document.querySelector('#user_id').value ?? '',
        };

        // Show loading splash before sending the request
        jQuery('body').caLoadingSplash('show');

        new Ajax.Request(
            url,
            {
                method: 'post',
                parameters: parameters,
                onSuccess() {
                    jQuery('body').caLoadingSplash('hide');
                },
                onFailure() {
                    jQuery('body').caLoadingSplash('hide');
                },
            },
        );
    };

    const processTransactionWithPlatformTransactionId = () => {
        disablePayButton();
        const url = '/payment/generate-cashflow-emv-transaction';
        const parameters = {
            'user_id': document.querySelector('#user_id').value ?? '',
        };

        $dialogContent.caDialog({
            title: 'Transaction In Progress...',
            resizable: false,
            width: 600,
            showCloseButton: false,
            modal: true,
        });

        new Ajax.Request(
            url,
            {
                method: 'post',
                parameters: parameters,
                onSuccess(response) {
                    if (response?.responseJSON?.status) {
                        platformTransactionId = response?.responseJSON?.data?.platformTransactionId;
                        processTransaction();
                    } else {
                        enablePayButton();
                        closeDialogBox(response?.responseJSON?.message ?? '');
                    }
                },
                onFailure() {
                    closeDialogBox('');
                    enablePayButton();
                },
            },
        );
    }

    const getAuthTransactionParameters = () => {
        const amountElement = document.querySelector('#amount');
        const emvAccountIdElement = document.querySelector('#emvAccountId');
        const emvPublicKeyElement = document.querySelector('#emvPublicKey');
        const emvTerminalIdElement = document.querySelector('#emvTerminalId');
        const infrastructureFeeIds = JSON.parse(params.infrastructureFeeIds);

        const totalAmount = Number(amountElement?.value);
        const gatewayEmvAccountId = parseInt(emvAccountIdElement?.value ?? '');
        let gatewayEmvPublicKey = emvPublicKeyElement?.value ?? '';
        gatewayEmvPublicKey = gatewayEmvPublicKey.trim();
        const emvTerminalId = parseInt(emvTerminalIdElement?.value ?? '');

        return {
            accountId: gatewayEmvAccountId,
            publicKey: gatewayEmvPublicKey,
            amount: totalAmount,
            terminalId: emvTerminalId,
            promptForTip: false,
            requestSignature: true,
            printReceipt: false,
            printExtraReceipt: false,
            isCapture: false,
            infrastructureFeeIds: infrastructureFeeIds,
        };
    }

    const processTransaction = async () => {
        try {
            const webSocketBaseUrl = params.webSocketEmvUrl ?? '';

            self.callTerminalInProgress = true;
            conn = new TerminalTransactionWebSocket({
                baseUri: webSocketBaseUrl,
                onTransactionError: handleOnTransactionError,
                onTransactionEvent: handleOnTransactionEvent,
                onTransactionSuccess: handleOnTransactionSuccess
            });

            const payload = getAuthTransactionParameters();
            payload.platformTransactionId = platformTransactionId;

            await conn.authTransaction(payload);
        } catch (e) {
            handleOnError(e);
        }
    }
    if (!self.callTerminalInProgress) {
        processTransactionWithPlatformTransactionId();
    }
};

CashFlowEMVTerminal.prototype.callTokenizationTerminal = function (params, callback) {
    const handleOnTokenizeEvent = function (data) {
        jQuery('body').caLoadingSplash('hide');
        if(!cancelStatusCheck) {
            $dialogContent.caDialog({
                title: 'Transaction In Progress...',
                resizable: false,
                width: 600,
                showCloseButton: false,
                modal: true
            });
        }
        if (data.message === cancelTransaction && data.status === cancelTransactionStatus) {
            jQuery.caAlert('Transaction has been cancelled.');
            $dialogContent.caDialog('close');
            $dialogContent.caDialog('destroy');
            cancelStatusCheck = 1;
            if (conn !== null) {
                conn.closeConnection().then(r => {
                    console.log('Terminal Connection Closed.');
                });
            }
        }
    };
    const handleOnTokenizeError = function (data) {
        jQuery('body').caLoadingSplash('hide');
        $dialogContent.caDialog('close');
        $dialogContent.caDialog('destroy');
        if (data.hasOwnProperty('errorMessage')) {
            jQuery.caAlert(data.errorMessage);
        }
        if (conn !== null) {
            conn.closeConnection().then(r => {
                console.log('Terminal Connection Closed on tokenization error.');
            });
        }

        callback(data);
    };
    const handleOnTokenizeSuccess = function (data) {
        $dialogContent.caDialog('close');
        $dialogContent.caDialog('destroy');
        if (conn !== null) {
            conn.closeConnection().then(r => {
                console.log('Terminal Connection Closed on tokenization success.');
            });
        }
        callback(data);
    };
    const processTransaction = async() => {
        const gatewayEmvAccountId = parseInt(document.querySelector('#emvAccountId')?.value);
        const gatewayEmvPublicKey = (document.querySelector('#emvPublicKey')?.value).toString();
        const emvTerminalId = parseInt(document.querySelector('#emvTerminalId')?.value);
        const webSocketBaseUrl = (document.querySelector('#webSocketEmvUrl')?.value).toString();
        jQuery('body').caLoadingSplash('show');

        try {
            conn = new TerminalTransactionWebSocket({
                baseUri: webSocketBaseUrl,
                onTokenizeEvent: handleOnTokenizeEvent,
                onTokenizeError: handleOnTokenizeError,
                onTokenizeSuccess: handleOnTokenizeSuccess
            });

            await conn.initiateTokenize({
                accountId: gatewayEmvAccountId,
                publicKey: gatewayEmvPublicKey,
                terminalId: emvTerminalId,
            });
        } catch (error) {
            jQuery('body').caLoadingSplash('hide');
        }
    };
    processTransaction();
};

export default CashFlowEMVTerminal;
